import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import userManagmentLogo from "../../../assets/images/user.png";
// import vesselInformation from "../../../assets/images/vesselicon1.png";
// import organizationIcon from "../../../assets/images/organization.png";


import { isSuperAdminLogin } from "../../../utils";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { GiCargoShip } from "react-icons/gi";
import { FaCircleUser } from "react-icons/fa6";
import { GrOrganization } from "react-icons/gr";
import DashboardIcon from "../../../assets/flaticons/dashboard.png";

let initialOptions = [
  {
    label: "Setup Organization",
    url: "/organization",
    svg: <GrOrganization />,
  },
  {
    label: "User Management for Organization",
    url: "/userOrganization",
    svg: <FaCircleUser />,
  },
  {
    label: "Vessel Information",
    url: "/vesselInformation",
    svg: <GiCargoShip />,
  },
  {
    label: "All Knowledge Partners",
    url: "/admin/knowledge-partners",
    svg: <FaCircleUser />,
  },
  {
    label: "Market Curve Analysis",
    url: "/market-curve-analysis",
    img: <img src={DashboardIcon} alt="" className="w-6 h-6" />,
  },
  {
    label: "My Market Curve Analysis",
    url: "/my-market-curve-analysis",
    img: <img src={DashboardIcon} alt="" className="w-6 h-6" />,
  },
];

export default function Dashboard() {
  const history = useHistory();
  const [dashboardOperations, setDashboardOperations] = useState([
    ...initialOptions,
  ]);

  useEffect(() => {
    if (!isSuperAdminLogin()) {
      let newDashboardOperations = dashboardOperations.filter(
        (item) => item.url !== "/vesselInformation" && item.url !== "/admin/knowledge-partners"
      );
      setDashboardOperations(newDashboardOperations);
    }
  }, []);

  return (
    <div className="dashboard-container min-h-[calc(100vh-106px)]">
      <div className="flex gap-2 items-center mb-3 text-slate-700">
        <MdOutlineAdminPanelSettings size={18} aria-hidden="true" />
        <p className="text-[12px]">Manage organizations, users, vessels, and market data.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {dashboardOperations.map((item) => (
          <button
            type="button"
            key={item.url}
            onClick={() => history.push(item.url)}
            className="min-h-[96px] p-4 bg-white border border-slate-300 rounded-none flex items-center gap-3 text-left text-slate-800 hover:bg-slate-50 hover:border-slate-400 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#313C4C]"
          >
            <span aria-hidden="true" className="shrink-0 text-[24px] text-[#313C4C]">{item.svg || item.img}</span>
            <span className="text-[12px] font-medium leading-5">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
